import { useMemo } from 'react';
import Image from 'next/image';
import type { SelectToken, UnifiedToken } from '@/types';
import { NETWORK_ICONS, UNIFIED_TOKENS } from '@/constants';

export function TokenIcon({
  token,
  width,
  height,
}: {
  token: SelectToken | UnifiedToken;
  width: number;
  height: number;
}) {
  const networkIcon =
    'network' in token && token.token_address
      ? NETWORK_ICONS[token.network as keyof typeof NETWORK_ICONS]
      : undefined;

  const icon = useMemo(() => {
    for (const unified of UNIFIED_TOKENS) {
      if (
        unified.tokens.some(
          ({ token_address, network }) =>
            token_address === token.token_address && network === token.network
        )
      ) {
        return unified.icon;
      }
    }

    return token.icon;
  }, [token]);

  return (
    <div
      className="relative"
      style={{ width, height, minWidth: width, minHeight: height }}
    >
      <Image
        className="rounded-full"
        src={icon}
        alt={token.id}
        width={width}
        height={height}
      />
      {networkIcon && (
        <div className="absolute -bottom-[2px] -right-[2px] rounded-full z-40 w-[50%] h-[50%] border border-white/50 border-solid">
          <Image
            className="relative top-0 left-0 rounded-full w-full h-full"
            src={networkIcon}
            alt={token.id}
            width={10}
            height={10}
          />
        </div>
      )}
    </div>
  );
}
